import type { ComposeFormInPopOutOptions } from 'owa-outlook-service-option-store';
import { getOptionsForFeature, OwsOptionsFeatureType } from 'owa-outlook-service-option-store';

export default function getComposeFormOption(): ComposeFormInPopOutOptions {
    return getOptionsForFeature<ComposeFormInPopOutOptions>(
        OwsOptionsFeatureType.ComposeFormInPopOut
    );
}
